module.exports = __webpack_public_path__ + "b2beae61e75b6d222039c7cf7a315b6c.png";


//////////////////
// WEBPACK FOOTER
// ./public/banner_2@2x.png
// module id = 189
// module chunks = 1